import classnames from 'classnames';
import PropTypes from 'prop-types';

import './style.scss';
import {Icon} from '@gisatcz/ptr-atoms';

const ControlPanelExpandButton = ({
	minimised,
	chartExpanded,
	onStatusChange,
}) => {
	const classes = classnames('insar-ControlPanelExpandButton', {
		'is-minimised': minimised,
		'is-chartExpanded': chartExpanded,
	});

	return (
		<div onClick={() => onStatusChange(!minimised)} className={classes}>
			<Icon icon="chevron-right" />
		</div>
	);
};

ControlPanelExpandButton.propTypes = {
	minimised: PropTypes.bool,
	chartExpanded: PropTypes.bool,
	onStatusChange: PropTypes.func,
};

export default ControlPanelExpandButton;
